<div class="d-flex align-items-center w-100">
    <div class="flex-fill me-1 overflow-hidden">
        <div>
            @if (inspections()) {
                <ng-select
                    (change)="openInspection()"
                    [(ngModel)]="inspection"
                    [clearable]="inspections()?.length > 1"
                    [items]="inspections()"
                    appendTo="body"
                    bindLabel="name"
                    placeholder="{{inspection ? 'Schouwronde' : 'Selecteer een schouwronde'}}">
                    <ng-template let-item="item" ng-label-tmp ng-option-tmp>
                        @if (item.lock) {
                            <i class="fa-duotone fa-lock"></i>
                        } {{item.name}}
                    </ng-template>
                </ng-select>
            }
        </div>
    </div>
    <div>
        <button mat-icon-button [matMenuTriggerFor]="menu"><i class="menu-item fa-regular fa-ellipsis-stroke-vertical"></i></button>
        <mat-menu #menu="matMenu">
            <button (click)="editInspection()" mat-menu-item>
                <mat-icon class="fas fa-edit d-inline-flex align-items-center me-1"></mat-icon>
                <span>Schouwronde aanpassen</span>
            </button>
            <button (click)="createInspection()" mat-menu-item>
                <mat-icon class="fas fa-plus d-inline-flex align-items-center me-1"></mat-icon>
                <span>Schouwronde toevoegen</span>
            </button>
            @if (!inspection?.lock && inspectionLock()) {
                <button (click)="lockInspection()" mat-menu-item>
                    <mat-icon class="fa-duotone fa-lock d-inline-flex align-items-center me-1"></mat-icon>
                    <span>Schouwronde vergrendelen</span>
                </button>
            }
            @if (inspection?.lock && inspectionLock()) {
                <button (click)="unlockInspection()" mat-menu-item>
                    <mat-icon class="fa-solid fa-unlock d-inline-flex align-items-center me-1"></mat-icon>
                    <span>Schouwronde ontgrendelen</span>
                </button>
            }
        </mat-menu>
    </div>
</div>
